import { z } from "zod";
export const BackupRestoreRehearsalRecordV1Schema = z
    .object({
    schemaVersion: z.literal("backup-restore-rehearsal.v1.0"),
    scheduleLabel: z.string().min(1),
    measuredRpoMinutes: z.number().int().nonnegative(),
    measuredRtoMinutes: z.number().int().nonnegative(),
    restoreOutcome: z.enum(["PASS", "FAIL"]),
    providerDrillClaimed: z.literal(false),
    recordedAt: z.string().datetime(),
})
    .strict();
export function recordLocalBackupRestoreRehearsal(input) {
    if (input.restoreOutcome !== "PASS") {
        throw new Error("backup_restore_rehearsal_failed");
    }
    return BackupRestoreRehearsalRecordV1Schema.parse({
        schemaVersion: "backup-restore-rehearsal.v1.0",
        providerDrillClaimed: false,
        ...input,
    });
}
//# sourceMappingURL=backup-restore-rehearsal.js.map